import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import "./activityCategories.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

import { selectCategory, updateCategories } from "../../redux/slices/activityCategories";
import ActivityCategory from "./activityCategory";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { fetchActivityCategories } from "../../services/activity";

// import Assessment from "../../assets/icons/assessments";
// import Games from "../../assets/icons/games";
// import MarketingPages from "../../assets/icons/marketingPages";
// import Themes from "../../assets/icons/themes";
// import Video from "../../assets/icons/video";

export default function ActivityCategories() {
  const { categories } = useSelector((state) => state.activityCategories);
  const location = useLocation();

  const [bottomSliderX, setBottomSliderX] = useState(0);
  const [swiperChanged, setSwiperChanged] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [bottomSliderIndex, setBottomSliderIndex] = useState(0);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperSlideRef = useRef(null);

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    if(categories.length >= 1) return
    fetchActivityCategories((err, res) => {
      if (res !== null) {
        console.log('categories', res.data);
        let categories = res.data;
        categories[0].isSelected = true;
        dispatch(updateCategories(categories));
      }
    });
  }, []);

  const handleClick = (id) => {
    dispatch(selectCategory({ id }));
  };

  return (
    <div className="activity_categories">
      <div className="activity_categories__swiper_container">
        <Swiper
          className="activity_categories__slider"
          slidesPerView={width <= 1100 ? "auto" : "auto"}
          spaceBetween={width <= 1100 ? 29 : 0}
          slidesPerGroup={1}
          onTransitionEnd={(e) => setSwiperChanged((prev) => prev + 1)}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onSlideChange={(e) => setActiveIndex(e.activeIndex)}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
          }}
          modules={[Navigation]}
        >
          {categories.map((category, idx) => {
            return (
              <SwiperSlide onClick={() => handleClick(category.id)} className="swiper-slide" key={idx} ref={swiperSlideRef}>
                <ActivityCategory {...category} setBottomSliderX={setBottomSliderX} swiperChanged={swiperChanged} setBottomSliderIndex={setBottomSliderIndex} index={idx} />
              </SwiperSlide>
            );
          })}
          {/* <div ref={navigationPrevRef} className='swiper__navigation_icon left'>
                        <img src='/assets/icons/left.svg' />
                    </div>
                    <div ref={navigationNextRef} className='swiper__navigation_icon right'>
                        <img src='/assets/icons/right.svg' />
                    </div> */}
        </Swiper>
        <div ref={navigationPrevRef} className="swiper__navigation_icon left">
          <img src="/assets/icons/left.svg" />
        </div>
        <div ref={navigationNextRef} className="swiper__navigation_icon right">
          <img src="/assets/icons/right.svg" />
        </div>
      </div>
      {location.pathname.substring(0,7) !== "/design" && (
        <div className={bottomSliderIndex < activeIndex ? "bottom_slider inactive" : "bottom_slider"} id={bottomSliderIndex < activeIndex + 5 ? "" : "inactive"} style={{ left: bottomSliderX }}>
          {" "}
        </div>
      )}
    </div>
  );
}
